import { PortalDsButton } from 'src/components/portal-design-system';
import type { CampaignStatus } from '../types/campaigns.types';
import {
  CAMPAIGN_REQUEST_ACTION_LABELS,
  getAvailableCampaignActions,
  type CampaignRequestAction,
} from '../utils/campaign-request-actions.utils';

interface CampaignRequestActionsProps {
  campaignId: string;
  status: CampaignStatus;
  assignedToEmail?: string | null;
  disabled?: boolean;
  onAction: (campaignId: string, action: CampaignRequestAction) => Promise<void>;
  layout?: 'inline' | 'stacked';
}

const ACTION_VARIANT: Record<CampaignRequestAction, 'primary' | 'secondary' | 'ghost'> = {
  claim: 'primary',
  unclaim: 'ghost',
  complete: 'secondary',
  close: 'ghost',
};

export function CampaignRequestActions({
  campaignId,
  status,
  assignedToEmail = null,
  disabled = false,
  onAction,
  layout = 'inline',
}: CampaignRequestActionsProps) {
  const actions = getAvailableCampaignActions(status, assignedToEmail);

  if (actions.length === 0) {
    return (
      <span className="text-[13px] text-[#9CA3AF]">
        —
      </span>
    );
  }

  return (
    <div
      className={layout === 'stacked'
        ? 'flex shrink-0 flex-col gap-2'
        : 'flex shrink-0 flex-wrap items-center justify-end gap-2'}
      onClick={(event) => event.stopPropagation()}
    >
      {actions.map((action) => (
        <PortalDsButton
          key={action}
          variant={ACTION_VARIANT[action]}
          size="sm"
          disabled={disabled}
          onClick={() => void onAction(campaignId, action)}
        >
          {CAMPAIGN_REQUEST_ACTION_LABELS[action]}
        </PortalDsButton>
      ))}
    </div>
  );
}
